// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelsCompositeInstanceState } from './ModelsCompositeInstanceState';
import {
  ModelsCompositeInstanceStateFromJSON,
  ModelsCompositeInstanceStateFromJSONTyped,
  ModelsCompositeInstanceStateToJSON,
  ModelsCompositeInstanceStateToJSONTyped,
} from './ModelsCompositeInstanceState';

/**
 *
 * @export
 * @interface ModelsCompositeInstanceStatus
 */
export interface ModelsCompositeInstanceStatus {
  /**
   *
   * @type {string}
   * @memberof ModelsCompositeInstanceStatus
   */
  appliedNeo4jVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsCompositeInstanceStatus
   */
  dnsName?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsCompositeInstanceStatus
   */
  errorDetail?: string;
  /**
   *
   * @type {ModelsCompositeInstanceState}
   * @memberof ModelsCompositeInstanceStatus
   */
  state?: ModelsCompositeInstanceState;
}

/**
 * Check if a given object implements the ModelsCompositeInstanceStatus interface.
 */
export function instanceOfModelsCompositeInstanceStatus(
  value: object,
): value is ModelsCompositeInstanceStatus {
  return true;
}

export function ModelsCompositeInstanceStatusFromJSON(
  json: any,
): ModelsCompositeInstanceStatus {
  return ModelsCompositeInstanceStatusFromJSONTyped(json, false);
}

export function ModelsCompositeInstanceStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ModelsCompositeInstanceStatus {
  if (json == null) {
    return json;
  }
  return {
    appliedNeo4jVersion:
      json['appliedNeo4jVersion'] == null
        ? undefined
        : json['appliedNeo4jVersion'],
    dnsName: json['dnsName'] == null ? undefined : json['dnsName'],
    errorDetail: json['errorDetail'] == null ? undefined : json['errorDetail'],
    state:
      json['state'] == null
        ? undefined
        : ModelsCompositeInstanceStateFromJSON(json['state']),
  };
}

export function ModelsCompositeInstanceStatusToJSON(
  json: any,
): ModelsCompositeInstanceStatus {
  return ModelsCompositeInstanceStatusToJSONTyped(json, false);
}

export function ModelsCompositeInstanceStatusToJSONTyped(
  value?: ModelsCompositeInstanceStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    appliedNeo4jVersion: value['appliedNeo4jVersion'],
    dnsName: value['dnsName'],
    errorDetail: value['errorDetail'],
    state: ModelsCompositeInstanceStateToJSON(value['state']),
  };
}
